export default __webpack_public_path__ + "media/images/features/toyono/toyonochou-5da81514c4bdba2e28d13d97623eeae0.png";